let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4rODC")).then(() => parcelRequire('lqny5'));